import { render } from "./Welcome.vue?vue&type=template&id=21fd005d&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=21fd005d&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fd005d"]])

export default __exports__